/* angular:styles/component:css;3bb1924dc0089e0d49352fab3adbb204eec09793ba4b55d09d6e6402b0b774d3;/src/src/app/edge/live/Controller/Evse/pages/history/history.ts */
form {
  align-content: center !important;
}
/*# sourceMappingURL=history.css.map */
